import Vue from 'vue';

import filters from '@filters/index.js';

Vue.use(filters);